import { deriveSeedProfile } from "@/lib/bap/seed-contract";

const WHITESPACE = /\s+/;
export const RECOVERY_WORD_COUNTS = [12, 15, 18, 21, 24] as const;

export function normalizeRecoveryWords(value: string): string {
	return value
		.normalize("NFKD")
		.trim()
		.toLowerCase()
		.split(WHITESPACE)
		.join(" ");
}

/** Random selection without replacement. Called only in a user event. */
export function selectChallengePositions(wordCount: number): number[] {
	if (!RECOVERY_WORD_COUNTS.some((count) => count === wordCount)) {
		throw new Error("Unsupported recovery word count");
	}
	const pool = Array.from({ length: wordCount }, (_, index) => index);
	const selected: number[] = [];
	while (selected.length < 3) {
		const range = pool.length;
		const limit = Math.floor(2 ** 32 / range) * range;
		let value: number;
		do {
			value = crypto.getRandomValues(new Uint32Array(1))[0];
		} while (value >= limit);
		selected.push(pool.splice(value % range, 1)[0]);
	}
	return selected.sort((a, b) => a - b);
}

export function checkChallengeAnswers(
	words: readonly string[],
	positions: readonly number[],
	answers: Readonly<Record<number, string>>
): boolean {
	return (
		positions.length === 3 &&
		new Set(positions).size === 3 &&
		positions.every(
			(position) =>
				Number.isInteger(position) &&
				position >= 0 &&
				position < words.length &&
				normalizeRecoveryWords(answers[position] ?? "") !== "" &&
				normalizeRecoveryWords(answers[position] ?? "") ===
					normalizeRecoveryWords(words[position])
		)
	);
}

/** Validate locally before passing normalized words to the recovery controller. */
export function validateRecoveryPhrase(value: string): string {
	const words = normalizeRecoveryWords(value);
	if (
		!RECOVERY_WORD_COUNTS.some((count) => count === words.split(" ").length)
	) {
		throw new Error("Unsupported recovery word count");
	}
	deriveSeedProfile(words, 0);
	return words;
}
